import axios from "axios";
import {
  baseUrl,
  // baseUrlManagement
} from "constants/url";
// const API_URL = `${baseUrlManagement}/api/auth/`;
const API_URL = `${baseUrl}/api/auth/`;
const register = (username, email, password) => {
  return axios.post(API_URL + "signup", {
    username,
    email,
    password,
  });
};
const login = (username, password, browserSaved) => {
  return axios
    .post(API_URL + "miassist-signin", {
      username,
      password,
      browserSaved
    })
    .then((response) => {
      console.log('response: => ', response);
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response.data;
    });
};
const logout = () => {
  localStorage.removeItem("user");
};
const forgotPassword = (email) => {
  return axios.post(API_URL + "forgotPassword", {
    email,
  });
};
const resetPassword = (resetToken, newPassword) => {
  return axios.post(API_URL + "resetPassword", {
    newPassword,
    resetToken,
  });
};
const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};
const AuthService = {
  register,
  login,
  logout,
  getCurrentUser,
  forgotPassword,
  resetPassword,
};
export default AuthService;